import React from 'react';
import {Container} from 'react-grid-system';

interface States {
}

interface Props {
}

class FooterSection extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <section
                className="footer">
                <Container>

                </Container>
            </section>
        )
    }
}


export default FooterSection;
